import { IconArrow } from 'components/Shared/Icon';
import { Button } from 'components/Button';
import { rm } from 'utils';
import connect from 'components/Shared/connect';
import styles from './editorials.scss';
import { EditorialsBlock } from 'models/EditorialsBlock';
import { ILocation } from 'models/ILocation';
import { EditorialsSection } from 'components/Editorials/editorials';

interface MergedProps extends EditorialsBlock {
  editorialsUrl: string;
  location?: ILocation;
}

const _Editorials = ({ editorials, editorialsUrl, location }: MergedProps) => {
  const showMorePath = location ? `${editorialsUrl}${location.pathname}` : editorialsUrl;
  return (
    <EditorialsSection editorials={editorials} sectionClassName={styles.margin}>
      <Button appearance="secondary" href={showMorePath} className={styles.showMore}>
        {rm('show_more')} <IconArrow size="small" />
      </Button>
    </EditorialsSection>
  );
};

export const Editorials = connect<MergedProps, EditorialsBlock>(state => ({
  editorialsUrl: state.appShell.links.editorials,
  location: state.location
}))(_Editorials);
